const itemSort = () => {
  const items = document.querySelector('[data-itemsort]');
  if (!items) return;
  const container = document.querySelector('.sorted-list');
  const listItems = items.querySelectorAll('li');
  // Collect items that match a first letter into groups
  const groups = {};
  listItems.forEach((li) => {
    const firstLetter = li.textContent.trim().charAt(0).toUpperCase();
    const link = li.querySelector('a').href;
    const linkText = li.innerText.trim();
    if (!groups[firstLetter]) {
      groups[firstLetter] = [];
    }
    groups[firstLetter].push(link, linkText);
  });
  // Sort the groups by their first letter
  const groupContent = (groups) => {
    Object.keys(groups).forEach((key) => {
      const group = groups[key];
      const groupList = document.createElement('ul');
      groupList.classList.add('group', 'x-mb-10', 'fade-in');
      groupList.innerHTML = `<li id=${key} class="group-title x-text-6xl x-border-b-2 x-border-black x-mb-10 x-text-black">${key}</li>`;
      groupList.innerHTML += group
        .map((item, index) => {
          if (index % 2 === 0) {
            return `<li class="x-mb-2"><a href="${
              group[index]
            }" class="underline-links-hover"><span>${
              group[index + 1]
            }</span></a></li>`;
          }
        })
        .join('');
      container.appendChild(groupList);
    });
  };
  // Inject groups into the items and remove the original list
  groupContent(groups);

  // const sideNav =
  const itemSortList = document.querySelector('[data-itemsortlist]');
  if (!itemSortList) return;

  const groupFilter = (groups) => {
    const groupList = document.createElement('ul');
    groupList.classList.add('group', 'x-mb-10', 'fade-in');
    Object.keys(groups).forEach((key) => {
      groupList.innerHTML += `<li class="x-text-black lg:x-mb-2 x-text-xl">
      <a href="#${key}" class="underline-links-hover"><span>${key}</span></a></li>`;
      itemSortList.appendChild(groupList);
    });
  };
  groupFilter(groups);

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      });
    });
  });
};

export const pages = () => {
  itemSort();
};
